import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const putOrg = async (org: AdminTypes.OrganizationDto) => {
  const res = await Api.put<AdminTypes.OrganizationDto>(
    `/admin/v1/orgs/${org.id}`,
    org,
  );

  return res.data;
};
